import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    title: 'Capital Food Products',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'restaurant/:id',
    title: 'Restaurant Menu & Order Online | Capital Food',
    loadComponent: () => import('./pages/restaurant/restaurant.component').then(m => m.RestaurantComponent)
  },
  {
    path: 'cart',
    title: 'Your Cart | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/cart/cart.component').then(m => m.CartComponent)
  },
  {
    path: 'about',
    title: 'About Us | Capital Food Products',
    loadComponent: () => import('./pages/about/about.component').then(m => m.AboutComponent)
  },
  {
    path: 'offers',
    title: 'Offers & Deals | Capital Food',
    loadComponent: () => import('./pages/offers/offers.component').then(m => m.OffersComponent)
  },
  {
    path: 'contact',
    title: 'Contact Us & FAQ | Capital Food',
    loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent)
  },
  {
    path: 'faq',
    title: 'FAQ - Help & Support | Capital Food',
    loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent)
  },
  {
    path: 'delivery-policy',
    title: 'Delivery Policy | Capital Food',
    loadComponent: () => import('./pages/delivery-policy/delivery-policy.component').then(m => m.DeliveryPolicyComponent)
  },
  {
    path: 'privacy-policy',
    title: 'Privacy Policy | Capital Food',
    loadComponent: () => import('./pages/privacypolicy/privacypolicy.component').then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'terms',
    title: 'Terms & Conditions | Capital Food',
    loadComponent: () => import('./pages/terms-condition/terms-condition.component').then(m => m.TermsConditionComponent)
  },
  {
    path: 'bulk-order',
    title: 'Bulk Order - Save 30% | Capital Food',
    loadComponent: () => import('./pages/offers/offers.component').then(m => m.OffersComponent)
  },
  {
    path: 'delivery-address',
    title: 'Delivery Address | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/product-delivery-address/product-delivery-address.component').then(m => m.ProductDeliveryAddressComponent)
  },
  {
    path: 'login',
    title: 'Login | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'login/:id',
    title: 'Login | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'order-summary',
    title: 'Order Summary | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/product-order-summary-component/product-order-summary-component.component').then(m => m.ProductOrderSummaryComponentComponent)
  },
  {
    path: 'process-payment',
    title: 'Process Payment | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/process-payment-component/process-payment-component.component').then(m => m.ProcessPaymentComponentComponent)
  },
  {
    path: "order",
    title: 'Order | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/order-history/order-history.component').then(m => m.OrderHistoryComponent)
  },
  {
    path: "payment-history",
    title: 'Payment | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/payment-history/payment-history.component').then(m => m.PaymentHistoryComponent)
  },
  {
    path: "payment-status",
    title: 'Payment Status | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/payment-status/payment-status.component').then(m => m.PaymentStatusComponent)
  },
  {
    path: "payment-success",
    title: 'Payment Success | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/payment-success/payment-success.component').then(m => m.PaymentSuccessComponent)
  },
  {
    path: "payment-fail",
    title: 'Payment Failed | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/payment-fail/payment-fail.component').then(m => m.PaymentFailComponent)
  },
  {
    path: "profile",
    title: 'My Profile | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent)
  },
  {
    path: "payment",
    title: 'Payment | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/payment/payment.component').then(m => m.PaymentComponent)
  },
  {
    path: "wallet",
    title: 'Wallet | Capital Food',
    data: { noindex: true },
    loadComponent: () => import('./pages/wallet-transaction/wallet-transaction.component').then(m => m.WalletTransactionComponent)
  },
  {
    path: 'cancellation-reschedule-refund-policy',
    title: 'Cancellation Reschedule Refund Policy | Capital Food',
    loadComponent: () => import('./pages/cancellation-refund-policy/cancellation-refund-policy.component').then(m => m.CancellationRefundPolicyComponent)
  },
  { path: '**', redirectTo: '' }
];